import { render, staticRenderFns } from "./UserGroupEdit.vue?vue&type=template&id=65f158a8"
import script from "./UserGroupEdit.vue?vue&type=script&lang=js"
export * from "./UserGroupEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports